var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
// const root =
//   // (typeof globalThis !== "undefined" && globalThis) ||
//   (typeof self !== "undefined" && self);
//   // || (typeof global !== "undefined" && global);
var root = self;
var shouldPolyfillEventTarget = (function () {
    // if (!import.meta.env.LEGACY) return false;
    try {
        new root.EventTarget();
    }
    catch (error) {
        return true;
    }
    return false;
})();
if (shouldPolyfillEventTarget) {
    root.EventTarget = /** @class */ (function () {
        function EventTarget() {
            Object.defineProperty(this, "__listeners", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            this.__listeners = new Map();
        }
        Object.defineProperty(EventTarget.prototype, "addEventListener", {
            enumerable: false,
            configurable: true,
            writable: true,
            value: function (type, listener, options) {
                if (arguments.length < 2) {
                    throw new TypeError("TypeError: Failed to execute 'addEventListener' on 'EventTarget': 2 arguments required, but only " +
                        arguments.length +
                        " present.");
                }
                var __listeners = this.__listeners;
                var actualType = type.toString();
                if (!__listeners.has(actualType)) {
                    __listeners.set(actualType, new Map());
                }
                var listenersForType = __listeners.get(actualType);
                if (listenersForType && !listenersForType.has(listener)) {
                    // Any given listener is only registered once
                    listenersForType.set(listener, options);
                }
            }
        });
        Object.defineProperty(EventTarget.prototype, "removeEventListener", {
            enumerable: false,
            configurable: true,
            writable: true,
            value: function (type, listener, _options) {
                if (arguments.length < 2) {
                    throw new TypeError("TypeError: Failed to execute 'addEventListener' on 'EventTarget': 2 arguments required, but only " +
                        arguments.length +
                        " present.");
                }
                var __listeners = this.__listeners;
                var actualType = type.toString();
                if (__listeners.has(actualType)) {
                    var listenersForType = __listeners.get(actualType);
                    if (listenersForType && listenersForType.has(listener)) {
                        listenersForType.delete(listener);
                    }
                }
            }
        });
        Object.defineProperty(EventTarget.prototype, "dispatchEvent", {
            enumerable: false,
            configurable: true,
            writable: true,
            value: function (event) {
                var e_1, _a;
                if (!(event instanceof Event)) {
                    throw new TypeError("Failed to execute 'dispatchEvent' on 'EventTarget': parameter 1 is not of type 'Event'.");
                }
                var type = event.type;
                var __listeners = this.__listeners;
                var listenersForType = __listeners.get(type);
                if (listenersForType) {
                    try {
                        for (var _b = __values(listenersForType.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
                            var listenerEntry = _c.value;
                            var listener = listenerEntry[0];
                            var options = listenerEntry[1];
                            try {
                                if (typeof listener === "function") {
                                    // Listener functions must be executed with the EventTarget as the `this` context.
                                    listener.call(this, event);
                                }
                                else if (listener && typeof listener.handleEvent === "function") {
                                    // Listener objects have their handleEvent method called, if they have one
                                    listener.handleEvent(event);
                                }
                            }
                            catch (err) {
                                // We need to report the error to the global error handling event,
                                // but we do not want to break the loop that is executing the events.
                                // Unfortunately, this is the best we can do, which isn't great, because the
                                // native EventTarget will actually do this synchronously before moving to the next
                                // event in the loop.
                                setTimeout(function () {
                                    throw err;
                                });
                            }
                            if (options && options.once) {
                                // If this was registered with { once: true }, we need
                                // to remove it now.
                                listenersForType.delete(listener);
                            }
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                }
                // Since there are no cancellable events on a base EventTarget,
                // this should always return true.
                return true;
            }
        });
        return EventTarget;
    }());
}
export {};
